export default {"src":"/_next/static/media/challenge-yard.f8135475.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};